import DolozkaZlucitelnostiEditPage from './DolozkaZlucitelnostiEditPage';

export default DolozkaZlucitelnostiEditPage;
